import Tokens from '../../tokens';

const Theme = {
  hover: {
    backgroundColor: Tokens.colors.hover,
  },
};

export default Theme;
